export default (value) => [null, true].includes(value);
